<div class="header" [class.scrolled]="isScrolled || !isHomePage">

  <!-- White logo: shown on transparent header (home page, not scrolled) -->
  <img class="logo white-logo" [class.d-none]="isScrolled || !isHomePage" src="../../../assets/img/white-logo.png"
    routerLink="/" />

  <!-- Dark logo: shown when scrolled OR not on home page -->
  <img class="logo dark-logo" [class.d-none]="!isScrolled && isHomePage" src="../../../assets/img/logo.png"
    routerLink="/" />

  <!-- Mobile hamburger icon -->
  <i #menu_icon class="bi bi-list d-block d-md-none pointer menu-icon"></i>

  <!-- ─── Navigation Menu ─── -->
  <ul class="tabs d-none d-md-flex" #header>

    <!-- Mobile: top row with close button -->
    <div class="mobile-header-top">
      <img src="../../../../assets/img/close.svg" class="d-block d-md-none pointer close-icon" #close_icon />
    </div>
    <!-- ── Search Bar (all users) ── -->
    <li>
      <div class="search-wrapper-container">
        <div class="search-wrapper">
          <i class="bi bi-search search-ico"></i>
          <input #searchInput type="text" [value]="searchQuery" (input)="onSearchInput(searchInput.value)"
            (keyup.enter)="onSearch()" placeholder="{{ 'Search' | translate }}" class="search-input"
            autocomplete="off" />
        </div>

        <!-- Search Results Dropdown -->
        <div *ngIf="showSearchResults && searchQuery.length >= 2" class="search-results-dropdown">
          <div *ngIf="searchLoading" class="search-loading">
            <div class="spinner-mini"></div>
            <span>{{ 'Searching' | translate }}...</span>
          </div>

          <div *ngIf="!searchLoading && searchError" class="search-error">
            <i class="bi bi-info-circle"></i>
            <span>{{ searchError }}</span>
          </div>

          <ul *ngIf="!searchLoading && searchResults.length > 0" class="search-results-list">
            <li *ngFor="let result of getSearchResultsPreview(); let i = index" (click)="selectSearchResult(result)"
              class="search-result-item">
              <div class="result-logo-mini"
                [style.background]="getSearchResultImage(result) ? 'transparent' : getSearchResultLogoBackground(i)">
                <img *ngIf="getSearchResultImage(result)" [src]="getSearchResultImage(result)"
                  [alt]="getSearchResultTitle(result) + ' logo'" class="result-logo-img" />
                <span *ngIf="!getSearchResultImage(result)">{{ getSearchResultAvatarLabel(result) }}</span>
              </div>
              <div class="result-info">
                <p class="result-name">{{ getSearchResultTitle(result) }}</p>
                <p class="result-type">{{ getSearchResultSubtitle(result) || getSearchResultBadge(result) }}</p>
              </div>
              <i class="bi bi-chevron-right"></i>
            </li>
          </ul>

          <div *ngIf="!searchLoading && searchTotalElements > 6" class="search-view-all">
            <a (click)="onSearch()">
              {{ 'View all results' | translate }}
              <span class="search-view-all-count">
                ({{ searchTotalElements - 6 }} {{ 'header.more' | translate }})
              </span>
              <i class="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    </li>

    <div class="line"></div>

    <!-- ── USER ONLY LINKS (Services + Articles + Contact) ── -->
    <ng-container *ngIf="!isCompanyPage">
      <li>
        <a class="tab-item" #tab_item routerLink="" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">{{ "Home" | translate }}</a>
      </li>
      <div class="line"></div>
      <!-- Services dropdown -->
      <li class="dropdown-service" [class.open]="servicesOpen">
        <a class="tab-item dropdown-toggle" (click)="toggleServices()">
          {{ "Services" | translate }}
          <span class="services-arrow">&#8250;</span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a routerLink="/careerCoach" (click)="closeMobileMenu()">
              {{ "Career Coaching" | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/scan-cv" (click)="closeMobileMenu()">
              {{ "Scan CV" | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/generatResume" (click)="closeMobileMenu()">
              {{ "Creation CV" | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/create-cover-letter" (click)="closeMobileMenu()">
              {{ "Creation Cover Letter" | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/create-linkedin-profile" (click)="closeMobileMenu()">
              {{ "linkedin_optimization" | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/scan-linkedin" (click)="closeMobileMenu()">
              {{ "Scan LinkedIn" | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/virtual-interview" (click)="closeMobileMenu()">
              {{ "Interview" | translate }}
            </a>
          </li>

        </ul>
      </li>

      <div class="line"></div>

      <!-- Articles -->
      <li>
        <a class="tab-item" #tab_item routerLink="/articles" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">{{ "Articles" | translate }}</a>
      </li>
      <div class="line"></div>

      <!-- Articles -->
      <li>
        <a class="tab-item" #tab_item routerLink="/job-list" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">{{ "Jobs" | translate }}</a>
      </li>


      <div class="line"></div>

      <!-- Contact -->
      <li>
        <a routerLink="/contact" class="tab-item" #tab_item routerLinkActive="active">{{ "Contact" | translate }}</a>
      </li>

      <div class="line"></div>

    </ng-container>

    <!-- ── COMPANY ONLY LINKS ── -->
    <ng-container *ngIf="isCompanyPage">

      <!-- Job Post -->

      <li>
        <a class="tab-item" #tab_item routerLink="/job-post" routerLinkActive="active">{{ "Job Post" | translate }}</a>
      </li>

      <div class="line"></div>
      <li>
        <a class="tab-item" #tab_item routerLink="/virtual-interview-company" routerLinkActive="active">{{ "Virtual
          Interview" |
          translate }}</a>
      </li>

      <div class="line"></div>

      <!-- Contact UpCareer -->
      <li>
        <a class="tab-item" #tab_item routerLink="/contact" routerLinkActive="active">{{ "Contact UpCareer" | translate
          }}</a>
      </li>

      <div class="line"></div>

    </ng-container>



    <!-- Language toggle -->
    <li>
      <a class="tab-item lang-btn" (click)="changeLang()">{{ userLang }}</a>
    </li>



    <!-- Dashboard button (company + logged in) -->
    <!-- <li *ngIf="accessToken && isCompany">
      <button class="button border-0 dashboard-btn" (click)="goToDashboard()">
        {{ "Dashboard" | translate }}
      </button>
    </li> -->

    <!-- ── Sign Up Button (guest on /home or /company-home) ── -->
    <li *ngIf="showSignUpButton">
      <button class="signup-btn" (click)="goToSignUp()">
        {{ (signUpType === 'company' ? 'Sign Up as Company' : 'Sign Up') | translate }}
      </button>
    </li>

    <!-- Profile avatar (logged in) -->
    <li *ngIf="accessToken && !isCompany" class="profile-menu user-profile-menu" [class.open]="profileMenuOpen">
      <div class="profile-header" (click)="toggleProfileMenu($event)">
        <div class="avatar-ring">
          <img *ngIf="userImage; else initialsBlock" [src]="userImage" alt="User Avatar" class="user-avatar" />
          <ng-template #initialsBlock>
            <div class="user-avatar initials">{{ getUserInitials() }}</div>
          </ng-template>
        </div>
        <div class="profile-info">
          <h4>{{ userName }}</h4>
          <p>{{ userTitle }}</p>
        </div>
      </div>

      <div class="profile-dropdown" *ngIf="profileMenuOpen">
        <button type="button" class="profile-dropdown-item" [class.active]="currentUrl === '/profile/personal-data'"
          (click)="goToPersonalData()">
          {{ 'header.myDashboard' | translate }}
        </button>
        <button type="button" class="profile-dropdown-item" [class.active]="currentUrl === '/user-profile'"
          (click)="goToProfessionalProfile()">
          {{ 'header.professionalProfile' | translate }}
        </button>
        <button type="button" class="profile-dropdown-item logout" (click)="logout()">
          {{ 'header.logout' | translate }}
        </button>
      </div>
    </li>

    <li *ngIf="accessToken && isCompany" class="profile-menu user-profile-menu" [class.open]="profileMenuOpen">
      <div class="profile-header" (click)="toggleProfileMenu($event)">
        <div class="avatar-ring">
          <img *ngIf="userImage; else companyInitialsBlock" [src]="userImage" alt="User Avatar" class="user-avatar" />
          <ng-template #companyInitialsBlock>
            <div class="user-avatar initials">{{ getUserInitials() }}</div>
          </ng-template>
        </div>
        <div class="profile-info">
          <h4>{{ userName }}</h4>
          <p>{{ "Company" | translate }}</p>
        </div>
      </div>

      <div class="profile-dropdown" *ngIf="profileMenuOpen">
        <button type="button" class="profile-dropdown-item" (click)="goToDashboard()">
          {{ 'Dashboard' | translate }}
        </button>
        <button type="button" class="profile-dropdown-item logout" (click)="logout()">
          {{ 'header.logout' | translate }}
        </button>
      </div>
    </li>

  </ul>
</div>